import { Outlet } from "react-router-dom";
import styles from "./AuthLayout.module.scss";

import Logo from "../../assets/icons/Logo";

export default function AuthLayout() {
  return (
    <div className={styles.authLayout}>
      <div className={styles.authLayoutImage}></div>
      <div className={styles.authOutlet}>
        <Logo />
        <Outlet />
      </div>
    </div>
  );
}
